import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type Store from '@ember-data/store'
import type SessionService from 'teacher-ui-client/services/session'
import type { UIScopeName } from 'teacher-ui-client/reporting/ui-scope/route'
import type SubscriptionCoordinator from 'teacher-ui-client/models/subscription-coordinator'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'

export default class extends Route {
  @service session!: SessionService

  @service contentfulClient!: ContentfulClientService

  @service store!: Store

  async model() {
    const { subscriptionType, subscriptionUtilisation } = this.modelFor(
      'subscription-type',
    ) as ModelForSubscriptionTypeRoute

    const { currentSchool, currentTeacher } = this.session

    const hsMaxWebinarResult = currentSchool?.isHomeschool
      ? await this.contentfulClient.getHomeschoolMaxWebinar({
          slug: 'homeschool-max-overview',
        })
      : undefined

    const homeschoolMaxVideoUrl = hsMaxWebinarResult?.fields.webinarVideo?.fields.file?.url

    if (currentSchool && currentTeacher) {
      const isSubco = currentTeacher.subcoFor(subscriptionType)

      const subcoForSubscription = this.store
        .peekAll<SubscriptionCoordinator>('subscription-coordinator')
        .find((subscriptionCoordinator) => subscriptionCoordinator.isForSubscriptionType(subscriptionType))?.teacher

      const scopeName: UIScopeName = isSubco ? 'school' : 'teacher'

      return {
        currentSchool,
        currentTeacher,
        subscriptionType,
        homeschoolMaxVideoUrl,
        subscriptionUtilisation,
        scopeName: scopeName,
        scopeId: isSubco ? currentSchool.id : currentTeacher.id,
        isSubco,
        subcoForSubscription,
      }
    } else {
      throw new Error('no school or teacher defined in home route model hook')
    }
  }
}
